module.exports = __webpack_public_path__ + "static/Mountain2-ff1a7a64f22c5025d34e1a1847aeab64.png";